<script>
    export default {
        name: "Sidebar",

        props: {
            sidebarIndex: Number
        },
        methods: {
            goTo(index) {
                this.$emit('go-to', index);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .btn-link {
        color: black;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/user/Sidebar.vue